import React, { useEffect, useState, useRef } from "react";

// import { APP_KEY, API_URL } from './../config';
import {
  getUser,
  isNumber,
  getTransactionId,
  dmtModeInArray,
} from "./../../Utils/Common";

// import Commingsoon from '../../container/commingsoon';
// import { Tabs, Tab } from 'react-bootstrap-tabs';
import {
  POST_SETTLEMENT_TO_BANK_SAVE,
  GET_PARENT_PROFILE,
  POST_PAYOUT_CHECK_BENEFICIARY,
  POST_PAYOUT_V2_ADD_MOVE_TO_BANK_BENEFICIARY,
  GET_BANK_SETTING_LIST
} from "./../../Utils/appConstants";


import axios from 'axios';

import { API_URL } from '../../config';

import { getRequest, postRequest } from "./../../Utils/AppApi";
// import Payout from './../payout';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import AfterSave from "./../../container/afterpayment";
import { Select } from "antd";
// import UpiComponent from './upi';
// import UpiComponent from './../upiTransfer';
// import PayoutV2 from './../payoutCashFree/landing';
import { getGeoLocation } from "../../Utils/function";
import PropagateLoader from "react-spinners/PropagateLoader";

function MoveToBank() {

  const user = getUser();

  console.log("user------", user.data);

  const history = useHistory();
  const eligibleLimit = 10000;
  const [getDataField, setDataField] = useState({});
  const [getDataError, setDataError] = useState({});
  const [partnerId, setPartnerId] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [myWalletBalance, setWalletBalance] = useState(0);
  const [InEligibleLimit, setEligibleLimit] = useState(10);
  const [ifscCode, setIfscCode] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [isSubmit, setSubmit] = useState(false);
  const [isTransactionLoading, setTransactionLoading] = useState(false);
  const [searchMode, setSearchMode] = useState(dmtModeInArray[0].value);
  const [beneficiary_id, setBeneficiaryID] = useState('');

  const [underMaintenance, setUnderMaintenance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('Under Maintenance');

  const amountInput = useRef(null);

  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(false);



  const fetchAppInfo = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL + `/appinfo`);
      setAppInfo(response.data);
    } catch (err) {
      console.error("Failed to fetch app info", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchAppInfo();
  }, []);

  const clearFormField = () => {
    amountInput.current.value = "";
  };

  const objectToQueryString = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  };

  const getDataReports = () => {
    // if (startDate && endDate) {
    // params.startDate = startDate ? startDate : "";
    // params.endDate = endDate ? endDate : "";
    // }
    const queryString = objectToQueryString({ page: 1, limit: 10 });
    getRequest(`${GET_BANK_SETTING_LIST}?${queryString}`, history).then((response) => {
      if (response.success === true) {
        // const defaultBankData = response.data.docs.find(doc => doc.isDefault === true);
        //         const defaultBankDataStatus = response.data.docs.find(doc => doc.status === true);

        // if (defaultBankData && defaultBankDataStatus) {
        //   setAccountNumber(defaultBankData.accountNumber);
        //   setIfscCode(defaultBankData.ifscCode);
        //   setBankName(defaultBankData.bankName);
        //   setAccountHolderName(defaultBankData.name);
        // }
        // setTotalRecord(response.data.totalDocs);
        // setPage(response.data.page);

        const defaultBankData = response.data.docs.find(
          doc => doc.isDefault === true && doc.status === true
        );

        if (defaultBankData) {
          setAccountNumber(defaultBankData.accountNumber);
          setIfscCode(defaultBankData.ifscCode);
          setBankName(defaultBankData.bankName);
          setAccountHolderName(defaultBankData.name);
        } else {
          // Optional: Handle the case where no valid default bank is found
          console.warn('No active default bank found');
          // e.g., setAccountNumber(''); or redirect to a setup page
        }

      } else {
        // setData([]);
        // setTotalRecord(0);
        // setPage(1);
        toast.error(response.message || 'Failed to load bank data');
      }
    }).catch(function (error) {
      console.log(error);
      toast.error('An error occurred while loading bank data');
      // setData([]);
      // setTotalRecord(0);
      // setPage(1);
    })
  };

  const onChangeValue = (event) => {
    const { name, value } = event.target;
    setDataField({ ...getDataField, [name]: value });
  };

  const FormValidate = () => {
    let formValid = true;
    let formObject = {};
    setDataError({});
    if (getDataField && Object.keys(getDataField).length === 0) {
      formValid = false;
    }

    let array = ["amount"];

    array.forEach((element) => {
      if (
        getDataField[element] === "" ||
        typeof getDataField[element] === "undefined"
      ) {
        formObject[element] = true;
        formValid = false;
      }

      if (getDataField.amount < 10000) {
        formValid = false;
        toast.error("Minimum amount per transaction is Rs. 10000");
      }

      if (Number(getDataField.amount) > Number(InEligibleLimit)) {
        formValid = false;
        toast.error("Eligible amount per transaction is Rs." + InEligibleLimit);
      }

      if (getDataField.amount > 100000) {
        formValid = false;
        toast.error("Maximum amount per transaction is Rs.100000");
      }

      if (!searchMode) {
        formValid = false;
        toast.error("Please select transfer mode");
      }
    });

    setDataError(formObject);
    return formValid;
  };

  const handleSubmit = async (beneID) => {
    if (!FormValidate()) return;

    setTransactionLoading(true);

    // const payload = {
    //   transactionId: getDataField.transactionId,
    //   ifsccode: ifscCode,
    //   accountNumber: accountNumber,
    //   partnerId: partnerId,
    //   partnerName: partnerName,
    //   amount: getDataField.amount,
    //   walletBalance: myWalletBalance,
    //   eligibleLimit: InEligibleLimit,
    //   channel: searchMode,
    //   latitude: latitude,
    //   longitude: longitude,
    //   beneficiaryId: beneID,
    //   txnType: "move_to_bank"
    // };

    const payload = {
      transactionId: getDataField.transactionId,
      ifsccode: ifscCode,
      accountNumber: accountNumber,
      customerId: partnerId,                   // unified name
      customerName: partnerName,
      beneficiaryId: beneID,                   // unified name
      beneficiaryName: partnerName,            // optional – can use same
      amount: getDataField.amount,
      walletBalance: myWalletBalance,
      eligibleLimit: InEligibleLimit,
      channel: searchMode,
      latitude: latitude,
      longitude: longitude,
      txnType: "move_to_bank"
    };

    setTransactionLoading(false);


    postRequest(POST_SETTLEMENT_TO_BANK_SAVE, payload, history)
      .then((response) => {
        if (response.success === true) {
          setDataField([]);
          setDataError({});
          clearFormField();
          setSubmit(true);
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch(function (error) {
        // console.log(error)
      });
    setTransactionLoading(false);

    // console.log('Submitting payload:', payload);  // Temp debug

    // let response;
    // try {
    //   response = await postRequest(POST_SETTLEMENT_TO_BANK_SAVE, payload, history);
    //   console.log('Transaction response (normal):', response);  // Temp debug
    // } catch (error) {
    //   console.error('Initial postRequest threw:', error);
    //   // Check if it's a "success" error (e.g., 201/202 for async)
    //   if (error.response && error.response.status >= 200 && error.response.status < 300) {
    //     response = error.response.data;
    //     console.log('Treating as success response from error:', response);  // Temp debug
    //   } else {
    //     // Re-throw real errors
    //     throw error;
    //   }
    // }

    // // Now process the response (whether from try or caught "success")
    // if (response && response.success === true) {
    //   setDataField({});
    //   setDataError({});
    //   clearFormField();
    //   setSubmit(true);
    //   toast.success(response.message || 'Transaction initiated successfully');
    // } else if (response) {
    //   toast.error(response.message || 'Transaction failed');
    // } else {
    //   toast.error('No response received');
    // }
  }; // eslint-disable-line react-hooks/exhaustive-deps


  const addBeneSave = async () => {
    const payload = {
      customerMobile: user.data.userDetails.mobile,
      recipientMobile: user.data.userDetails.mobile,
      accountNumber: accountNumber,
      ifscCode: ifscCode,
      bankId: "0",
      bankName: bankName,
      recipientName: accountHolderName,
      beneBankName: bankName,
      apiName: "PAYOUTV2",
      latitude: latitude,
      longitude: longitude,
      isRemittanceBene: false,
    };

    console.log('Add beneficiary payload:', payload);  // Temp debug

    try {
      const response = await postRequest(`${POST_PAYOUT_V2_ADD_MOVE_TO_BANK_BENEFICIARY}`, payload, history);
      console.log('Add beneficiary response:', response);  // Temp debug
      if (response.success === true) {
        // toast.success(response.message);
        // getDataReports();
        // setBeneData({});
        // setAddBaneModal(false);
        setBeneficiaryID(response.data.beneficiary_id);

        console.log('About to call handleSubmit with beneId:', response.data.beneficiary_id);  // Temp debug

        await handleSubmit(response.data.beneficiary_id);

      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while adding beneficiary');
    }
  };


  const getParentProfile = () => {
    getRequest(`${GET_PARENT_PROFILE}`, history)
      .then((response) => {
        if (response.success === true) {
          setWalletBalance(response.data.walletdetail.balance?.toFixed(2));
          setEligibleLimit(response.data.moveToBankEligbleAmount.toFixed(2));

          // setEligibleLimit(10000);
        } else {
          setWalletBalance(0);
          setEligibleLimit(0);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }; // eslint-disable-line react-hooks/exhaustive-deps


  const getBeneData = async () => {

    if (!FormValidate()) return;

    setTransactionLoading(true);

    const payload = {
      ifscCode: ifscCode,
      accountNumber: accountNumber,
    };

    console.log('Beneficiary check payload:', payload);  // Temp debug

    try {
      const response = await postRequest(`${POST_PAYOUT_CHECK_BENEFICIARY}`, payload, history);
      console.log("Beneficiary check response:", response);

      const beneId = response.data?.beneficiary_id;

      const isValidBeneId = typeof beneId === "string" && beneId.trim().length > 0;

      if (response.success === true && isValidBeneId) {
        setBeneficiaryID(beneId);


        // console.log("beneficiary_id", "" + beneId);  // Fixed: log beneId, not stale state



        // console.log("About to call handleSubmit with beneId:", beneId);  // Temp debug

        await handleSubmit(beneId);
      } else {


        await addBeneSave();

        // handleSubmit();
      }
    } catch (error) {
      console.error("Error in beneficiary check:", error);
      toast.error('An error occurred while checking beneficiary');
    } finally {
      setTransactionLoading(false);
    }
  };
  // eslint-disable-line react-hooks/exhaustive-deps


  const fetchLocation = async () => {
    let data = await getGeoLocation();
    setLatitude(data.latitude);
    setLongitude(data.longitude);
  };

  const getID = async () => {
    const transactionId = await getTransactionId();
    // console.log("Transaction ID:", transactionId);
    setDataField({ ...getDataField, transactionId: transactionId });
  };

  useEffect(() => {
    getID();
    getParentProfile();
    fetchLocation();
    getDataReports();
    setPartnerId(user.data.username);
    setPartnerName(user.data.name);
    // setPartnerName(user.data.userDetails.bankName);
    console.log("User data:", user);
    console.log("data.mobile:", user?.data?.mobile);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeTypeMode = (value) => {
    // const { value } = event;
    // console.log(`selected ${value}`);
    setSearchMode(value);
  };

  // const onchangeTab = (index, value) => {
  //   // setTabName(value.props.title);
  // }

  if (isTransactionLoading) {
    return (
      <div className="content text-center" style={{ margin: "250px 0" }}>
        <PropagateLoader color="#5851D2" loading={isTransactionLoading} size={25} />
      </div>
    );
  }

  if (appInfo && appInfo.moveToBankEnabled === false) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        background: '#f8f9fa'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center',
          height: 'fit-content', // Add this to make height fit content
          minHeight: 'auto' // Add this to prevent full height
        }}>
          <div style={{
            fontSize: '48px',
            color: '#f59e0b',
            marginBottom: '20px'
          }}>
            ⚙️
          </div>

          <h3 style={{
            color: '#1e293b',
            marginBottom: '15px',
            fontSize: '1.5rem'
          }}>
            Under Maintenance
          </h3>

          <p style={{
            color: '#64748b',
            marginBottom: '25px',
            lineHeight: '1.5'
          }}>
            {appInfo.moveToBankMessage || "Move To Bank service is currently unavailable. Please contact support for more information."}
          </p>

          <button
            style={{
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              padding: '10px 24px',
              borderRadius: '6px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#2563eb';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#3b82f6';
              e.target.style.transform = 'translateY(0)';
            }}
            onClick={() => history.push('/dashboard')}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }
  return (

    <div>
      {isSubmit ? (
        <AfterSave status={1} message={"Money send successful"} />
      ) : (
        <div className="content-wrapper pt-2">
          <div className="content-header my-0 py-0">
            <div className="container-fluid">
              <div className="row mb-0 align-items-center">
                <div className="col-sm-6">
                  <h1 className="page-title text-blue font-merriweather">
                    Move To <span className="text-red">Bank</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <div className="container-fluid pt-2 pb-5">
              <div className="row">
                <div className="col-md-12">
                  <div className="card rounded-0 card-body">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Transaction ID</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="transactionId"
                            value={getDataField && getDataField.transactionId}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Partner ID</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="partnerId"
                            value={partnerId}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Name</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="partnerName"
                            value={partnerName}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Account Number</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="accountNumber"
                            value={accountNumber}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>IFSC Code</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="ifscCode"
                            value={ifscCode}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Wallet Balance</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="walletbalance"
                            value={myWalletBalance}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Eligible Limit</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110`}
                            name="eligibleLimit"
                            value={InEligibleLimit}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label>Amount</label>
                          <input
                            type="text"
                            className={`form-control normal-light pr-110 ${getDataError && getDataError.amount
                              ? "is-invalid"
                              : ""
                              }`}
                            name="amount"
                            ref={amountInput}
                            maxLength={6}
                            onChange={(e) => onChangeValue(e)}
                            placeholder="Amount"
                            onKeyDown={isNumber}
                            value={getDataField && getDataField.amount}
                          />
                          {getDataError && getDataError.amount && (
                            <span className="error text-danger">
                              The field is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <div className="form-group">
                          <label className=" normal-light pr-110">&nbsp;</label>
                          <Select
                            options={dmtModeInArray}
                            className={`normal-light w-100`}
                            classNamePrefix="select"
                            isDisabled={true}
                            placeholder="-- Payment Mode --"
                            defaultValue={dmtModeInArray[0].value}
                            name="mode"
                            onChange={(e) => onChangeTypeMode(e)}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-4">
                        <label></label>
                        <div className="col-md-12 d-flex">
                          <div className="form-group  pull-right text-lg-right mr-4">
                            <button
                              type="submit"
                              className="btn btn-default rounded-pill pl-4 pr-4"
                              onClick={() => clearFormField()}
                            >
                              Cancel
                            </button>
                          </div>
                          <div className="form-group text-lg-right">
                            <button
                              type="submit"
                              className="btn btn-primary rounded-pill pl-4 pr-4"
                              onClick={() => getBeneData()}
                              disabled={isTransactionLoading}
                            >
                              Process
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h3>
                      <u>Terms & Conditions</u>
                    </h3>
                    <div className="row ml-2 mt-2">
                      <div className="m-0">
                        <p className="m-0">
                          * Transfer timings are between 09:00 AM to 05:00 PM
                          daily.
                        </p>
                        <p className="m-0">
                          * Maximum 5 transaction allowed per day.
                        </p>
                        <p className="m-0">
                          * Minimum amount per transaction is Rs.10000
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            limit={2}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>




      )}
    </div>


  );
}

export default MoveToBank;